<template>
  <section id="page-cars">
    <div class="container">
      <div class="row" v-show="cars.length === 0">

        <clearfix :biggest="true"></clearfix>

        <div class="col-sm-12 content og-bg-light">
          <div>{{ $t('message.text.cars.no_cars') }}</div>
        </div>

        <clearfix :biggest="true"></clearfix>
      </div>

      <div class="row" v-show="cars.length > 0">
        <clearfix :biggest="true"></clearfix>
      </div>

      <!-- Dealer Section - Begin -->
      <div class="row" v-show="isDealer">
        <transition name="slide-fade">
          <div class="col-sm-12 content og-bg-light" v-show="!addingCar">
            <b-button :size="'large'" :variant="'secondary'" @click.prevent="addingCar = true">
              <icon name="plus-square"></icon>&nbsp;
              {{ $t('message.button.add_vehicle') }}
            </b-button>
          </div>
        </transition>
        <transition name="slide-fade">
          <div class="col-sm-12 content og-bg-light" v-show="addingCar">
            <div class="og-form">
              <h3>{{ $t('message.title.admin.add_new_vehicle') }}</h3>
              <table>
                <tr>
                  <!-- Left side of form -->
                  <td>
                    <table>
                      <tr>
                        <td class="align-right"><label for="new-brand">{{ $t('message.form.brand') }}:</label></td>
                        <td>
                          <input type="text" id="new-brand" v-model="newCar.brand" @change="$v.newCar.brand.$touch()">
                          <span v-show="$v.newCar.brand.$error" class="form-error-message">&nbsp;{{ $t('message.error.brand') }}</span>
                        </td>
                        <td class="align-right"><label for="new-model">{{ $t('message.form.model') }}:</label></td>
                        <td>
                          <input type="text" id="new-model" v-model="newCar.model" @change="$v.newCar.model.$touch()">
                          <span v-show="$v.newCar.model.$error" class="form-error-message">&nbsp;{{ $t('message.error.model') }}</span>
                        </td>
                      </tr>

                      <tr>
                        <td class="align-right"><label for="new-year">{{ $t('message.form.year') }}:</label></td>
                        <td>
                          <input type="text" id="new-year" v-model="newCar.year" @change="$v.newCar.year.$touch()">
                          <span v-show="$v.newCar.year.$error" class="form-error-message">&nbsp;{{ $t('message.error.year') }}</span>
                        </td>
                        <td class="align-right"><label for="new-price">{{ $t('message.form.price') }}:</label><br></td>
                        <td>
                          <input type="text" id="new-price" v-model="newCar.price" @change="$v.newCar.price.$touch()">
                          <span v-show="$v.newCar.price.$error" class="form-error-message">&nbsp;{{ $t('message.error.price') }}</span>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
                <tr>
                  <td colspan="4">
                    <label for="new-description">{{ $t('message.form.description') }}:</label><br>
                    <quill-editor id="new-description"
                                  v-model="newCar.description"
                                  @change="changeDescription" style="height: 100%; width: 100%"
                                  :options="quillOptionsDescription"></quill-editor>
                    <span v-show="$v.newCar.description.$error" class="form-error-message">&nbsp;{{ $t('message.error.description') }}</span>
                  </td>
                </tr>
              </table>
            </div>

            <br>&nbsp;

            <b-button :size="'sm'" :variant="'secondary'" @click.prevent="addingCar = false">
              <icon name="times-circle"></icon>&nbsp;
              {{ $t('message.button.hide') }}
            </b-button>
            <b-button :size="'sm'" :variant="'secondary'" @click="saveNewVehicle">
              <icon name="check-circle"></icon>&nbsp;
              {{ $t('message.button.save') }}
            </b-button>
          </div>
        </transition>
      </div>

      <clearfix :bootstrap="true" v-show="isDealer"></clearfix>
      <!-- Dealer Section - End -->

      <div class="row" v-show="cars.length > 0" v-for="car in cars">
        <div class="col-sm-12 content og-bg-light">

          <!-- Dealer Section - Begin -->
          <div class="car-edit-menu" v-show="isDealer">
            <span :title="$t('message.title.admin.icons.hot_status_' + car.status)" v-show="car.status === 'HOT' || car.status === 'AVAILABLE'" @click="saveStatus(car.id, (car.status === 'HOT' ? 'AVAILABLE' : 'HOT'))">
              <icon name="fire" :class="'is-enabled-' + (car.status === 'HOT')"></icon>
            </span>
            <span :title="$t('message.title.admin.icons.hide')" v-show="car.status === 'HOT' || car.status === 'AVAILABLE'" @click="saveStatus(car.id, 'HIDDEN')">
              <icon name="eye" class="is-enabled-true"></icon>
            </span>
            <span :title="$t('message.title.admin.icons.make_available')" v-show="car.status !== 'HOT' && car.status !== 'AVAILABLE'" @click="saveStatus(car.id, 'AVAILABLE')">
              <icon name="eye-slash" class="is-enabled-false"></icon>
            </span>
            <span :title="$t('message.title.admin.icons.update_photos')" @click="$router.push({ name: 'CarPhotos', params: { id: car.id } })">
              <icon name="camera-retro"></icon>
            </span>
            <span :title="$t('message.title.admin.icons.sell')" v-show="car.status !== 'SOLD'" @click="saveStatus(car.id, 'SOLD')">
              <icon name="money"></icon>
            </span>
            <span :title="$t('message.title.admin.icons.delete')" v-show="car.status !== 'DELETED'" @click="saveStatus(car.id, 'DELETED')">
              <icon name="trash"></icon>
            </span>
          </div>
          <div class="car-edit-menu" style="clear: right" v-show="isDealer">
            {{ $t('message.title.admin.rec_status') }}:&nbsp;
            <span :class="'status-' + car.status">{{ $t('message.status.' + car.status) }}</span>
          </div>
          <!-- Dealer Section - End -->

          <h4>
            <router-link :to="{name: 'Car', params: {id: car.id}}">{{ car.brand }} {{ car.model }} ({{ car.year }})</router-link>
          </h4>

          <div class="car-photo" v-show="car.photos.length > 0"
               :style="{ backgroundImage: 'url(\'' + $t(imageBase, {car_id: car.id, file_name: getPhotoFileName(car.photos)}) + '\')', width: '300px', height: '200px' }">
          </div>

          <div class="car-description" v-html="car.description"></div>
        </div>

        <clearfix :wide="true"></clearfix>
      </div>

      <div class="row" v-show="cars.length > 0">
        <clearfix :biggest="true"></clearfix>
      </div>
    </div>
  </section>
</template>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  import VueAxios from 'vue-axios'
  import 'vue-awesome/icons'
  import Icon from 'vue-awesome/components/Icon.vue'
  import miniToastr from 'mini-toastr'
  import {quillEditor} from 'vue-quill-editor'

  import Clearfix from '../utils/Clearfix'

  import { validationMixin } from 'vuelidate'
  import { required, minLength } from 'vuelidate/lib/validators'

  import config from './Config'

  Vue.use(VueAxios, axios)

  export default {
    data() {
      return {
        cars: [],
        newCar: {},
        addingCar: false,

        quillOptionsDescription: {placeholder: this.$t('message.form.placeholder.description')},

        imageBase: config.urls.image_url
      }
    },
    components: {Clearfix, Icon, quillEditor},
    validations: {
      newCar: {
        brand: { required, minLength: minLength(2) },
        description: { required, minLength: minLength(2) },
        model: { required, minLength: minLength(2) },
        price: { required, minLength: minLength(2) },
        year: { required, minLength: minLength(2) }
      }
    },
    mixins: [ validationMixin ],
    computed: {
      isDealer() {
        return this.$store.state.auth.dealer
      }
    },
    methods: {
      changeDescription({html}) {
        this.newCar.description = html
        this.$v.newCar.description.$touch()
      },
      getPhotoFileName(photos) {
        if (photos.length > 0) {
          return photos[0].fileName
        }
        return ''
      },
      saveNewVehicle() {
        this.$v.$touch()

        if (this.$v.newCar.$invalid) {
          miniToastr.warn(this.$t('message.notification.create_not_valid'))
          return false
        }

        Vue.axios.post(config.urls.car, this.newCar)
          .then(() => {
            miniToastr.success(this.$t('message.notification.created'))
            this.newCar = {}
            this.addingCar = false
            this.loadVehicles()
          })
          .catch(() => {
            miniToastr.error(this.$t('message.notification.create_failed'))
          })
      },

      saveStatus(id, status) {
        Vue.axios.put(this.$t(config.urls.car_update_status, {car_id: id}), {data: status})
          .then(() => {
            miniToastr.success(this.$t('message.notification.status_set', {status_val: status}))
            this.loadVehicles()
          })
          .catch(() => {
            miniToastr.error(this.$t('message.notification.status_not_set'))
          })
      },

      loadVehicles() {
        Vue.axios.get(config.urls.car)
          .then((response) => {
            this.cars = response.data
          })
      }
    },
    created() {
      this.loadVehicles()
    }
  }
</script>

<style>
  #page-cars {
    background: url('../../assets/img/bg/bg_renault_engine.jpg') center fixed no-repeat;
    background-size: cover;
    height: auto;
    margin: 0 auto;
    width: 100%;
    position: relative;
    padding: 30px 0;
  }
</style>



// WEBPACK FOOTER //
// CarList.vue?32fa3800